import { CPButton, CustomisedTertiaryButton, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import { getPendoId } from "../../../util/cfstPendoUtils";
import RedesignedModal from "../../common/RedesignedModal";
import PropTypes from "prop-types";

function DiscardChangesModal({ handleDiscardChangeModal }) {
  return (
      <RedesignedModal
        opened={true}
        onClickClose={() => handleDiscardChangeModal("close")}
        zIndex={"1001"}
        title={"Discard changes?"}
        ModalAriaLabel="Discard changes modal"
        closeIconId={getPendoId("discard-modal-close-icon-button")}
        button={
          <>
            <CustomisedTertiaryButton
              ariaLabel="Cancel"
              onClick={() => handleDiscardChangeModal("close")}
              buttonWidth={"100%"}
              buttonHeight={"40px"}
              fontSize={"14px"}
              id={getPendoId("discard-modal-cancel-button")}
            >
              {`CANCEL`}
            </CustomisedTertiaryButton>
            <CPButton
              width="autoTight"
              id={getPendoId("discard-modal-discard-button")}
              buttonHeight={"40px"}
              buttonWidth={"100%"}
              ariaLabel="Discard"
              boxButton={true}
              onClick={() => handleDiscardChangeModal("discard")}
              style={{ height: "2.5rem" }}
              fontSize={"14px"}
            >
              {`DISCARD`}
            </CPButton>
          </>
        }
      >
        <Wrapper fontFamily="neue-haas-grotesk-text" fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0">
          {"The changes you have made will not be saved."}
        </Wrapper>
      </RedesignedModal>
  );
};

DiscardChangesModal.propTypes = {
  handleDiscardChangeModal: PropTypes.func.isRequired,
};

export default DiscardChangesModal;